import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IdValidatorService {
  
  /**
   * Validates if a string is a valid MongoDB ObjectId
   * @param id The ID to validate
   * @returns True if the ID is a valid MongoDB ObjectId (24-character hex string)
   */
  public isValidMongoId(id: string | undefined | null): boolean {
    return !!id && /^[0-9a-f]{24}$/i.test(id);
  }
  
  /**
   * Extracts claims from a JWT token
   * @param token The JWT token
   * @returns The decoded payload or null if invalid
   */
  public extractJwtClaims(token: string): any | null {
    try {
      const tokenParts = token.split('.');
      if (tokenParts.length !== 3) {
        return null;
      }
      
      const base64Url = tokenParts[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      
      return JSON.parse(atob(base64));
    } catch (e) {
      console.error('Error extracting JWT claims:', e);
      return null;
    }
  }
  
  /**
   * Extracts and validates the MongoDB ObjectId from a JWT token
   * @param token The JWT token
   * @param claimName The name of the claim containing the ID
   * @returns The validated MongoDB ObjectId or null if invalid
   */
  public extractMongoIdFromToken(token: string, claimName: string): string | null {
    const claims = this.extractJwtClaims(token);
    if (!claims || !claims[claimName]) {
      return null;
    }
    
    const id = claims[claimName];
    return this.isValidMongoId(id) ? id : null;
  }
}
